import { AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';
import { NgxPaginationModule } from 'ngx-pagination';
import { OnlysuperuserDirective } from '../../../../shared/directives/onlysuperuser.directive';
import { PermisionDirective } from '../../../../shared/directives/permision.directive';
import { MatDividerModule } from '@angular/material/divider';
import { Componente } from '../../../../core/models/component.interface';
import { Pagination } from '../../../../core/models/pagination.interface';
import { catchError, map, Observable, switchMap, tap } from 'rxjs';
import { LayoutService } from '../../../../core/services/layout/layout';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from '../../../../core/services/loading/loading';
import { ComponentService } from '../../../../core/services/component/component';
import { Title } from '@angular/platform-browser';
import { PAGINATION } from '../../../../core/constants/constants';
import { Filter, QueryGet } from '../../../../core/types/query-types';
import { ComponentForm } from '../component-form/component-form';
import { Search } from "../../../../shared/components/search/search";

@Component({
  selector: 'app-component-list',
  imports: [
    MatIcon,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    NgxPaginationModule,
    AsyncPipe,
    OnlysuperuserDirective,
    PermisionDirective,
    Search
],
  templateUrl: './component-list.html',
  styleUrl: './component-list.scss',
})
export class ComponentList {
  public page = 1;
  @Input() filtro: string = '';
  @Input() orden: string = '';
  limit = 10;
  total = 0;
  components: Componente[] = [];
  asyncComponent!: Observable<Componente[]>;
  selectedComponent: Componente | null = null;
  showColumns: string[] = [
    'acciones',
    'id',
    'name',
    'description',
    'risk',
    'objective',
    'result',
    'line',
  ];

  constructor(
    private layoutService: LayoutService,
    private activatedRouter: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private componentService: ComponentService,
    private loadingService: LoadingService,
    private title: Title,
  ) {
    this.title.setTitle('Componentes');
  }

  ngOnInit(): void {
    this.layoutService.paginationLimit$
      .pipe(
        switchMap((limit) => {
          this.limit = limit;
          return this.activatedRouter.queryParamMap;
        }),
        switchMap((params) => {
          const pageNum = params.get('page') || '1';
          const search = params.get('search') || '';
          this.page = parseInt(pageNum);
          this.fetchComponent(PAGINATION.first_page, null, search);
          return this.layoutService.paginationLimit$;
        }),
      )
      .subscribe();
  }

  fetchComponent(page: number, filter: Filter | null = null, search = '') {
    const offset = page > 1 ? page * this.limit - this.limit : 0;
    const params: QueryGet = {
      order: '-id',
      limit: this.limit,
      offset,
      search,
      filters: [],
    };
    if (filter) {
      params.filters.push(filter);
    }
    this.page = page;
    this.loadingService.show(true);
    this.asyncComponent = this.componentService.getComponent(params).pipe(
      tap((data) => {
        this.components = data.results;
        this.componentService.setComponent(data.results[0]);
        this.componentService.setComponents(data.results);
        this.total = data.count;
      }),
      map((res) => {
        this.loadingService.show(false);
        return res.results;
      }),
      catchError((error) => {
        this.loadingService.show(false);
        const errorMsg = `¡Se ha producido un error, inténtelo nuevamente!`;
        this.toastr.error(errorMsg, 'Error!', {
          progressBar: true,
          timeOut: 5000,
        });
        this.router.navigate(['home']);
        return [];
      }),
    );
  }

  createComponent() {
    this.componentService.removeComponentSelected();
    const dialogRef = this.dialog.open(ComponentForm, {
      width: '600px',
      height: 'auto',
      maxHeight: '80vh',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.fetchComponent(this.page);
    });
  }

  updateComponent(component: Componente) {
    this.componentService.setComponent(component);
    const dialogRef = this.dialog.open(ComponentForm, {
      width: '600px',
      height: 'auto',
      maxHeight: '80vh',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.fetchComponent(this.page);
    });
  }

  eliminate(component: Componente): void {
    const confirmed = window.confirm(`¿Estás seguro de eliminar el registro: ${component.name}?`);
    if (!confirmed) return;
    this.componentService.delete(component.id).subscribe({
      next: () => {
        const successMsg = `Eliminado CORRECTAMENTE!`;
        this.toastr.success(successMsg, 'Exitoso!', {
          progressBar: true,
          timeOut: 5000,
        });
        this.fetchComponent(this.page);
      },
      error: (err) => {
        this.toastr.error('No se pudo eliminar', 'Error');
      },
    });
  }
}
